import { aboutInfo } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-8 text-center">
            {aboutInfo.title}
          </h2>
          <div className="space-y-5">
            {aboutInfo.paragraphs.map((p, idx) => (
              <p key={idx} className="text-foreground-600 text-sm md:text-base leading-relaxed">
                {p}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}